import i18n from "@/i18n";
import { toast, toastI18n } from "@/components/common/Toast";
import { request } from "@/utils/api/legacyRequest";
import { doRedirect } from "../metadata/metadataActions";
import { fetchUserEmailAddresses } from "../userEmailAddresses/userEmailAddressActions";

const t = (key) =>
  i18n.getDataByLanguage(i18n.language)?.['translation.notification']?.[key] ?? key;

export function processEmailVerification(token) {
  return (dispatch, getState) => {
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/public/accounts/email-verification/${0}`;
    const userId = getState().user.get("id");

    const payload = {
      email_verification: {
        token,
      },
    };
    return request(url, null, "PUT", payload)
      .then(() => {
        dispatch(doRedirect(userId ? `/profile/${userId}` : "/"));
        dispatch(toast.hide());
        dispatch(toastI18n('success', 'EmailVerified'));
        if (userId) dispatch(fetchUserEmailAddresses());
      })
      .catch(() => {
        dispatch(doRedirect(userId ? `/profile/${userId}` : "/"));
        dispatch(toastI18n('error', 'InvalidToken'));
      });
  };
}

export function requestEmailVerification(emailAddress) {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");

    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/accounts/email-verification`;

    const payload = {
      email_verification: {
        email_address: emailAddress,
      },
    };
    request(url, jwt, "POST", payload).then(() => {
      dispatch(toast.success(`${t('EmailVerificationSent')} ${emailAddress}. ${t('VerifyHere')}`));
    });
  };
}

export function isEmailVerified() {
  return (dispatch, getState) => {
    const { userEmailAddresses, metadata } = getState();

    if (metadata.isVerifyingEmail) {
      return;
    }

    userEmailAddresses.forEach((uea) => {
      if (!uea.get("is_verified")) {
        const emailAddress = uea.get("email_address");
        dispatch(
          toast.warning(`${t('VerifyEmail')} ${emailAddress}`, {
            hideDuration: null,
            action: {
              label: t('SendVerificationEmail'),
              fn: () => dispatch(requestEmailVerification(emailAddress)),
            },
          })
        );
      }
    });
  };
}
